import React from 'react';

const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const ApiDocsPage: React.FC = () => (
  <div style={{ background: '#fff', borderRadius: 12, padding: 24 }}>
    <h2>API 문서</h2>
    <p>
      서버 API 명세는 <a href={`${apiBaseUrl}/api-docs`} target="_blank" rel="noopener noreferrer">Swagger UI</a>에서 확인할 수 있습니다.<br />
      (서버에서 swagger-ui-express 등으로 /api-docs 엔드포인트 제공 필요)
    </p>
    <ul>
      <li>회원가입/로그인/소셜로그인</li>
      <li>컨텐츠/게시판/댓글/첨부파일/알림 등 모든 엔드포인트 명세</li>
      <li>요청/응답 예시, 파라미터, 인증 방식 등</li>
    </ul>
  </div>
);

export default ApiDocsPage; 
